<template>
  <a-config-provider :locale="zhCN">
      <router-view />
      <!--  -->
  </a-config-provider>
</template>

<script>
document.title = "后台管理系统";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
  setup() {
      return {
          zhCN,
      };
  },
}
</script>
<style>
body, #app{
    height: 100%;
}
body{
    overflow-x: hidden;
}
#app{
    width: 100%;
    height: 100%;
}

.cursor_pointer{
    cursor: pointer;
}

@media screen and (max-width: 1600px){
    #app{
        width: 111.111111%;
        height: 111.111111%;
        transform: scale(0.9);
        transform-origin: 0 0;
    }

    body .ant-popover,
    body .ant-tooltip{
        transform: scale(0.9);
    }
    body .ant-popover-placement-top,
    body .ant-popover-placement-topLeft,
    body .ant-popover-placement-topRight,
    body .ant-tooltip-placement-top,
    body .ant-tooltip-placement-topLeft,
    body .ant-tooltip-placement-topRight{
        transform-origin: 50% 100%;
    }
    body .ant-popover-placement-bottom,
    body .ant-popover-placement-bottomLeft,
    body .ant-popover-placement-bottomRight,
    body .ant-tooltip-placement-bottom,
    body .ant-tooltip-placement-bottomLeft,
    body .ant-tooltip-placement-bottomRight{
        transform-origin: 50% 0%;
    }
    body .ant-popover-placement-left,
    body .ant-popover-placement-leftTop,
    body .ant-popover-placement-leftBottom,
    body .ant-tooltip-placement-left,
    body .ant-tooltip-placement-leftTop,
    body .ant-tooltip-placement-leftBottom{
        transform-origin: 100% 50%;
    }
    body .ant-popover-placement-right,
    body .ant-popover-placement-rightTop,
    body .ant-popover-placement-rightBottom,
    body .ant-tooltip-placement-right,
    body .ant-tooltip-placement-rightTop,
    body .ant-tooltip-placement-rightBottom{
        transform-origin: 0% 50%;
    }

    body .ant-dropdown,
    body .ant-select-dropdown,
    body .ant-picker-dropdown,
    body .ant-notification{
        transform: scale(0.9);
        transform-origin: 0 0;
    }

    body .ant-pagination-options .ant-select-dropdown,
    body .ant-pagination-options-size-changer .ant-select-dropdown{
        transform: none !important;
        transform-origin: initial;
    }

    body .ant-pagination-options,
    body .ant-pagination-options-size-changer{
        position: relative;
    }
    body .ant-pagination-options-size-changer .ant-select-dropdown{
        left: auto !important;
        right: 0 !important;
    }
    body .ant-pagination-options-size-changer .ant-select-dropdown-placement-bottomLeft,
    body .ant-pagination-options-size-changer .ant-select-dropdown-placement-bottomRight{
        top: 100% !important;
        bottom: auto !important;
    }
    body .ant-pagination-options-size-changer .ant-select-dropdown-placement-topLeft,
    body .ant-pagination-options-size-changer .ant-select-dropdown-placement-topRight{
        top: auto !important;
        bottom: 100% !important;
    }

    body .ant-pagination-options .ant-select-dropdown,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-enter,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-appear,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-leave,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-enter-active,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-appear-active,
    body .ant-pagination-options .ant-select-dropdown.ant-slide-up-leave-active{
        animation: none !important;
    }

    body .ant-message{
        left: 50%;
        transform: translateX(-50%) scale(0.9);
        transform-origin: 50% 0;
    }

    body .ant-modal{
        transform: scale(0.9);
        transform-origin: 50% 0;
    }

    body .ant-drawer-content-wrapper{
        transform: scale(0.9);
    }
    body .ant-drawer-left .ant-drawer-content-wrapper{
        transform-origin: 0 0;
    }
    body .ant-drawer-right .ant-drawer-content-wrapper{
        transform-origin: 100% 0;
    }
    body .ant-drawer-top .ant-drawer-content-wrapper{
        transform-origin: 50% 0;
    }
    body .ant-drawer-bottom .ant-drawer-content-wrapper{
        transform-origin: 50% 100%;
    }

    @keyframes antZoomIn {
      0% {
        transform: scale(0.18);
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        opacity: 1;
      }
    }
    @keyframes antZoomOut {
      0% {
        transform: scale(0.9);
        opacity: 1;
      }
      100% {
        transform: scale(0.18);
        opacity: 0;
      }
    }
    @keyframes antZoomBigIn {
      0% {
        transform: scale(0.72);
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        opacity: 1;
      }
    }
    @keyframes antZoomBigOut {
      0% {
        transform: scale(0.9);
        opacity: 1;
      }
      100% {
        transform: scale(0.72);
        opacity: 0;
      }
    }
    @keyframes antZoomUpIn {
      0% {
        transform: scale(0.72);
        transform-origin: 50% 0%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        transform-origin: 50% 0%;
        opacity: 1;
      }
    }
    @keyframes antZoomUpOut {
      0% {
        transform: scale(0.9);
        transform-origin: 50% 0%;
        opacity: 1;
      }
      100% {
        transform: scale(0.72);
        transform-origin: 50% 0%;
        opacity: 0;
      }
    }
    @keyframes antZoomLeftIn {
      0% {
        transform: scale(0.72);
        transform-origin: 0% 50%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        transform-origin: 0% 50%;
        opacity: 1;
      }
    }
    @keyframes antZoomLeftOut {
      0% {
        transform: scale(0.9);
        transform-origin: 0% 50%;
        opacity: 1;
      }
      100% {
        transform: scale(0.72);
        transform-origin: 0% 50%;
        opacity: 0;
      }
    }
    @keyframes antZoomRightIn {
      0% {
        transform: scale(0.72);
        transform-origin: 100% 50%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        transform-origin: 100% 50%;
        opacity: 1;
      }
    }
    @keyframes antZoomRightOut {
      0% {
        transform: scale(0.9);
        transform-origin: 100% 50%;
        opacity: 1;
      }
      100% {
        transform: scale(0.72);
        transform-origin: 100% 50%;
        opacity: 0;
      }
    }
    @keyframes antZoomDownIn {
      0% {
        transform: scale(0.72);
        transform-origin: 50% 100%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9);
        transform-origin: 50% 100%;
        opacity: 1;
      }
    }
    @keyframes antZoomDownOut {
      0% {
        transform: scale(0.9);
        transform-origin: 50% 100%;
        opacity: 1;
      }
      100% {
        transform: scale(0.72);
        transform-origin: 50% 100%;
        opacity: 0;
      }
    }

    @keyframes antSlideUpIn {
      0% {
        transform: scale(0.9) scaleY(0.8);
        transform-origin: 0% 0%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9) scaleY(1);
        transform-origin: 0% 0%;
        opacity: 1;
      }
    }
    @keyframes antSlideUpOut {
      0% {
        transform: scale(0.9) scaleY(1);
        transform-origin: 0% 0%;
        opacity: 1;
      }
      100% {
        transform: scale(0.9) scaleY(0.8);
        transform-origin: 0% 0%;
        opacity: 0;
      }
    }
    @keyframes antSlideDownIn {
      0% {
        transform: scale(0.9) scaleY(0.8);
        transform-origin: 100% 100%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9) scaleY(1);
        transform-origin: 100% 100%;
        opacity: 1;
      }
    }
    @keyframes antSlideDownOut {
      0% {
        transform: scale(0.9) scaleY(1);
        transform-origin: 100% 100%;
        opacity: 1;
      }
      100% {
        transform: scale(0.9) scaleY(0.8);
        transform-origin: 100% 100%;
        opacity: 0;
      }
    }
    @keyframes antSlideLeftIn {
      0% {
        transform: scale(0.9) scaleX(0.8);
        transform-origin: 0% 0%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9) scaleX(1);
        transform-origin: 0% 0%;
        opacity: 1;
      }
    }
    @keyframes antSlideLeftOut {
      0% {
        transform: scale(0.9) scaleX(1);
        transform-origin: 0% 0%;
        opacity: 1;
      }
      100% {
        transform: scale(0.9) scaleX(0.8);
        transform-origin: 0% 0%;
        opacity: 0;
      }
    }
    @keyframes antSlideRightIn {
      0% {
        transform: scale(0.9) scaleX(0.8);
        transform-origin: 100% 0%;
        opacity: 0;
      }
      100% {
        transform: scale(0.9) scaleX(1);
        transform-origin: 100% 0%;
        opacity: 1;
      }
    }
    @keyframes antSlideRightOut {
      0% {
        transform: scale(0.9) scaleX(1);
        transform-origin: 100% 0%;
        opacity: 1;
      }
      100% {
        transform: scale(0.9) scaleX(0.8);
        transform-origin: 100% 0%;
        opacity: 0;
      }
    }
}

/* 自定义 NProgress 进度条样式 */
#nprogress .bar {
  background: #29d !important; /* 进度条颜色：蓝色 */
  z-index: 1031 !important; /* 确保显示在最顶层 */
}
#nprogress .peg {
  box-shadow: 0 0 10px #29d, 0 0 5px #29d !important;
}
</style>
